<template>
  <div  style="overflow-y:auto; overflow-x:hidden;background:#2f455c; ">
    <el-menu class="el-menu-vertical"  style="border:1px solid #2f455c; "  router :unique-opened="true"  :default-openeds="[$route.matched[0].path]" :collapse="true"   >
      <!-- <div style="line-height:35px;  "> 
        <img style="height:35px; color:#5cadff;width:100%; "   src="@/assets/title.png"/>
      </div> -->
      <div v-for="(item ,ind) in menuList" :key="ind" >
        <el-submenu  :index="item.frmurl"   >
          <template v-if="ind==0" slot="title">          
              <div   style="display:flex;line-height:20px;height:20px;margin-left:-17px;padding-top:12px;margin-top:1px; "  >
                <div style="width:30px;padding-top:2px "> <i class="iconfont " :class="item.icon" style="font-size:20px;color:#ccc;margin-right:8px"></i> </div>
                <div class="modFont" @click="oneClick"  >{{item.name}} </div>
              </div>
          </template>
          <template v-else slot="title">          
              <div   style="display:flex;line-height:20px;height:20px;margin-left:-17px;padding-top:12px; "  >
                <div style="width:30px;padding-top:2px "> <i class="iconfont " :class="item.icon" style="font-size:20px;color:#ccc;margin-right:8px"></i> </div>
                <div class="modFont" @click="oneClick"  >{{item.name}} </div>
              </div>
          </template>
          <div style="width:490px;display:flex;flex-wrap:wrap; margin-top:-4px;max-height:calc(100vh - 150px);overflow-y:auto;" >
 
            <div v-show="item.children.filter(item=>item.vicon=='N').length>0" style="margin-top:-4px;background:#808695;width:490px;line-height:30px;height:30px; font-weight:600;font-size:12px;color:#fff">
                <i class="iconfont icon-biaodanzujian-biaoge" style="margin-left:3px;margin-rigth:3px;color:#fff"></i>
                <span style=" margin-left:4px; height:25px;padding-left:5px">表单类</span>
            </div>
            <div style="width:480px;background:white;display:flex;flex-wrap:wrap;margin-top:1px;margin-bottom:1px" >
              <div v-for="(subitem,index)  in item.children.filter(item=>item.vicon=='N')" :key="index" >
                <el-menu-item >
                  <a @click="topClick(subitem.frmurl,subitem.islock)"  :underline="false" :disabled="subitem.islock==='Y'">
                      <div class="submenu-div" >
                        <i class="iconfont icon-yuandianxiao" style="color:red;font-size:12px;margin-right:3px;line-height:45px;height:45px"></i> 
                        <div style="line-height:45px;height:45px;font-size:12px; " >{{subitem.name}} </div>
                      </div>
                  </a>
                </el-menu-item>
              </div>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='B').length>0" style="background:#808695;width:490px;line-height:30px;height:30px; font-weight:600;font-size:12px;color:#fff">
                <i class="iconfont icon-jichuziliaoguanli" style="margin-left:3px;margin-rigth:3px;color:#fff"></i>
                <span style=" margin-left:4px; height:25px;padding-left:5px">基础类</span>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='B').length>0" style="width:480px;background:white;display:flex;flex-wrap:wrap;min-height:30px;margin-top:1px;margin-bottom:1px" >
              <div v-for="(subitem,index)  in item.children.filter(item=>item.vicon=='B')" :key="index"  >
                <el-menu-item >
                  <a @click="topClick(subitem.frmurl,subitem.islock)"  :underline="false" :disabled="subitem.islock==='Y'">
                      <div class="submenu-div" >
                        <i class="iconfont icon-yuandianxiao" style="color:red;font-size:12px;margin-right:3px;line-height:45px;height:45px"></i> 
                        <div style="line-height:45px;height:45px;font-size:12px; " >{{subitem.name}} </div>
                      </div>
                  </a>
                </el-menu-item>
              </div>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='P').length>0" style="background:#808695;width:490px;line-height:30px;height:30px;  font-weight:600;font-size:12px;color:#fff">
                <i class="iconfont icon-baogao" style="margin-left:3px;margin-rigth:3px;color:#fff"></i>
                <span style=" margin-left:4px; height:25px;padding-left:5px">计划类</span>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='P').length>0" style="width:480px;background:white;display:flex;flex-wrap:wrap;min-height:30px;margin-top:1px;margin-bottom:1px" >
              <div v-for="(subitem,index)  in item.children.filter(item=>item.vicon=='P')" :key="index" >
                <el-menu-item >
                  <a @click="topClick(subitem.frmurl,subitem.islock)"  :underline="false" :disabled="subitem.islock==='Y'">
                      <div class="submenu-div" >
                        <i class="iconfont icon-yuandianxiao" style="color:red;font-size:12px;margin-right:3px;line-height:45px;height:45px"></i> 
                        <div style="line-height:45px;height:45px;font-size:12px; " >{{subitem.name}} </div>
                      </div>
                  </a>
                </el-menu-item>
              </div>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='C').length>0" style="background:#808695;width:490px;line-height:30px;height:30px; font-weight:600;font-size:12px;color:#fff">
                <i class="iconfont icon-gongyinglian2" style="margin-left:3px;margin-rigth:3px;color:#fff"></i>
                <span style=" margin-left:4px; height:25px;padding-left:5px">排产类</span>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='C').length>0" style="width:480px;background:white;display:flex;flex-wrap:wrap;min-height:30px;margin-top:1px;margin-bottom:1px" >
              <div v-for="(subitem,index)  in item.children.filter(item=>item.vicon=='C')" :key="index"  >
                <el-menu-item >
                  <a @click="topClick(subitem.frmurl,subitem.islock)"  :underline="false" :disabled="subitem.islock==='Y'">
                      <div class="submenu-div" >
                        <i class="iconfont icon-yuandianxiao" style="color:red;font-size:12px;margin-right:3px;line-height:45px;height:45px"></i> 
                        <div style="line-height:45px;height:45px;font-size:12px; " >{{subitem.name}} </div>
                      </div>
                  </a>
                </el-menu-item>
              </div>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='A').length>0" style="background:#808695;width:490px;line-height:30px;height:30px; font-weight:600;font-size:12px;color:#fff">
                <i class="iconfont icon-duanxin1" style="margin-left:3px;margin-rigth:3px;color:#fff"></i>
                <span style=" margin-left:4px; height:25px;padding-left:5px">我的邮箱</span>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='A').length>0" style="width:480px;background:white;display:flex;flex-wrap:wrap;min-height:30px;margin-top:1px;margin-bottom:1px" >
              <div v-for="(subitem,index)  in item.children.filter(item=>item.vicon=='A')" :key="index"  >
                <el-menu-item >
                  <a @click="topClick(subitem.frmurl,subitem.islock)"  :underline="false" :disabled="subitem.islock==='Y'">
                      <div class="submenu-div" >
                        <i class="iconfont icon-yuandianxiao" style="color:red;font-size:12px;margin-right:3px;line-height:45px;height:45px"></i> 
                        <div style="line-height:45px;height:45px;font-size:12px; " >{{subitem.name}} </div>
                      </div>
                  </a>
                </el-menu-item>
              </div>
            </div>

            <div v-show="item.children.filter(item=>item.vicon=='Y').length>0" style="background:#808695;width:490px;line-height:30px;height:30px; font-weight:600;font-size:12px;color:#fff;">
                <i class="iconfont icon-gaojichazhao" style="margin-left:3px;margin-rigth:3px;color:#fff"></i>
                <span style=" margin-left:4px; height:25px;padding-left:5px">查询类</span>
            </div>
            <div v-show="item.children.filter(item=>item.vicon=='Y').length>0" style="width:480px;background:white;display:flex;flex-wrap:wrap;min-height:30px;margin-top:1px;margin-bottom:1px" >
              <div v-for="(subitem,index)  in item.children.filter(item=>item.vicon=='Y')" :key="index"  >
                <el-menu-item >
                  <a @click="topClick(subitem.frmurl,subitem.islock)"  :underline="false" :disabled="subitem.islock==='Y'">
                      <div class="submenu-div" >
                        <i class="iconfont icon-yuandianxiao" style="color:red;font-size:12px;margin-right:3px;line-height:45px;height:45px"></i> 
                        <div style="line-height:45px;height:45px;font-size:12px; " >{{subitem.name}} </div>
                      </div>
                  </a>
                </el-menu-item>
              </div>
            </div>
            <div style=" line-height:15px;height:15px; font-weight:600;font-size:12px;color:#3D7878"></div>
          </div>
        </el-submenu>
      </div>      
    </el-menu>
    <el-dialog :visible.sync="promptWin" width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
            <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
        </div> 
        <span>{{prompt}}</span>
        <span slot="footer"  >
            <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
        </span>
    </el-dialog>
    <!-- <el-dialog :visible.sync="mainWin">
      <myPanel v-bind:repArr="repList"></myPanel>
    </el-dialog> -->
  </div>
</template>

<script>
import {  getBaseData} from '../api/user'
//import myPanel from '../views/Main.vue'
export default {
  computed: {
    isShowingLeftLayout () {
      return this.$store.state.isShowingLeftLayout
    },
    tabHeight: function() {
        return (window.innerHeight - 100) + 'px';
    },
    navActive() {
        const path = this.$route.path.split("/")
        console.log('/' + path[1])
        return '/' + path[1]
    }
  },
  components: {
    //myPanel,
  },
  data(){
    return {
      activeSubmenu:'/base',
      menuList: [],
      promptWin:false,
      prompt:'',
      mainWin:false,
      LANG:'',
      repList:[],
      title:this.$cookies.get('v_corpnm'),
 
      v_idseq :this.$cookies.get('v_idseq'),
      v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
      isHovered:true,
    }
  },
  methods:{
    oneClick(){
      console.log('...one')
    },
    //模块点击事件
    topClick(val,lock){
      if (lock !=='Y') {
       this.$router.push({
            path: val,
        }, () => {})
        this.$axios.post('xuper_auth/formOneSave',{
            p_json:JSON.stringify({'url':val,'userno':this.$cookies.get('v_telno'),'corpid':this.v_corpid}), p_table:'userlog' 
        }) 
      }
    },
    getMenuList(){ 
        //用户菜单 
        this.$axios.post('xuper_auth/getBaseData', {   
            p_table:'V_SYS_ROLE_USER',p_key:'USERID',p_value:this.v_idseq,p_key2:'stfg',p_value2:'Y',p_key3:'corpid',p_value3:this.v_corpid 
        }).then(res=>{ 
            let v_idseq =res.result[0]['IDSEQ']
            this.$axios.post('xuper_auth/getUserMenu', 
                { p_idseq :v_idseq,p_cond:' and isfront=\'N\''}
 
            ).then(res =>{
              if(res.code==='200'){
                this.menuList =res.result  
              }else{
                this.$alert(res.result, '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
              }
            })
        })
    }
  },
  mounted () { 
 
      this.getMenuList()
 
  }
}
</script>

<style lang="less"  >
 
  .el-menu--collapse .el-submenu__title span{
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }
  .el-menu--collapse .el-submenu__icon-arrow{
    display: none;
  }
   .el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
      margin-left:1px !important;
  }
  .el-menu-item, .el-submenu-item{
    margin-bottom:2px;
 
  }
  .el-submenu__title {
    border-radius: 3px 3px 3px 3px;  
  }
  
 .el-menu-vertical{
    box-sizing: border-box;
    width: 70px !important ; 
    background:#2f455c !important;
  }
  .el-menu-vertical :hover{
    background:transparent !important;
  }
 
  .el-menu-item {
    height: 45px !important;
    line-height: 45px !important;  
    background-color: transparent !important;
  }
 
    .el-table__body-wrapper {
      &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background-color: #fff;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ccc;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: #389;
      } 
    }

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }
 
    ::-webkit-scrollbar-track {
        background-color: #e8eff5;
    }
 
    ::-webkit-scrollbar-thumb {
        background-color: #ccc;
    }
 
    ::-webkit-scrollbar-thumb:hover {
        background-color: #389;
    } 
 
    ::-webkit-scrollbar-thumb:active {
        background-color: #389;
    }
    .el-menu-item:hover {
      background: #f7f8f9 !important;
      font-weight:700;
      font-size:14px;
      color:#389 !important;
      border-radius: 4px 4px 4px 4px;
    }
    .el-submenu.is-opened .el-submenu__title {
 

      background-image:   #5f86af !important;//linear-gradient(to right, #1B82DB, #20DFE1);
      background-color: #5f86af !important;
 
      border-right:3px solid #f04c23;
 
    }
</style>
<style scoped lang="less">
 
  .submenu-div{
      width:200px;
      font-size:12px;
      font-weight:600;
      display:flex;
      height: 44px;
      margin-top:1px;
      vertical-align: middle;
  }
  .submenu-div:hover{
    font-size:14px !important;
    color:#cc0000;
    font-weight:700;
  }

  .modFont{
    font-weight:600;
    color:#fff; 
    font-size:12px;
    line-height:20px;
    padding-top:3px
  }
 
   .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .el-cascader-panel{
        height: 40vh;
        .el-scrollbar__wrap{
            height:98%;
        }
    }
</style>
